export const PAGES_WITH_GREY_LAYOUT = ["/store", "/search", "product"];
